import {Controller} from "stimulus";

export default class extends Controller
{
    static targets = ["loading", "icon"];

    ABORT_CONTROLLER = new AbortController();
    RUNNING_REQUEST = false;

    connect()
    {
        this.element.addEventListener("click", e =>
        {
            this.iconTarget.classList.add("hidden");
            this.loadingTarget.classList.remove("hidden");

            let siteNum = this.element.dataset["siteNum"];

            let now = new Date();
            let nowTime = now.toLocaleTimeString("eu-EU"),
                nowDate = now.toISOString().split("T")[0];
            
            now.setHours(now.getHours() - 24);

            let beforeTime = now.toLocaleTimeString("eu-EU"),
                beforeDate = now.toISOString().split("T")[0];

            let parameters = {
                "procedure": "rpDetailedActivity",
                "serverCommand": null,
                "sqlTimeout": null,
                "applicationCode": null,
                "parameterDictionary": [
                    {
                        "Name": "SiteGroupSearch",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "SiteNum",
                        "Value": {
                            "Value": siteNum
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "StartDate",
                        "Value": {
                            "Value": beforeDate
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "StartTime",
                        "Value": {
                            "Value": beforeTime
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "EndDate",
                        "Value": {
                            "Value": nowDate
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "EndTime",
                        "Value": {
                            "Value": nowTime
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "StartTransmitterCode",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "EndTransmitterCode",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "ReportCodeList",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "ReportFrequency",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "Option",
                        "Value": {
                            "IsNull": true,
                            "Value": ""
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "CombineTransmittersFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "InclDataChangesFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "ExcludeTestFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "ExcludeOOSFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "IncludeOpActFlag",
                        "Value": {
                            "Value": "Y"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "ExcludeOpActCommentFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "FileType",
                        "Value": {
                            "Value": "PDF"
                        },
                        "IsOutput": false
                    },
                    {
                        "Name": "OneSitePerPageFlag",
                        "Value": {
                            "Value": "N"
                        },
                        "IsOutput": false
                    }
                ],
                "file_type": "PDF"
            }

            if(this.RUNNING_REQUEST)
            {
                this.ABORT_CONTROLLER.abort();
                this.ABORT_CONTROLLER = new AbortController();
            }
            this.RUNNING_REQUEST = true;
            fetch(window.App.prefixedUrl("/generate-report/execute"),
            {
                method: "POST",
                body: JSON.stringify(parameters),
                headers: { "content-type":"application/json" },
                signal: this.ABORT_CONTROLLER.signal
            })
             .then(res =>
            {
                if(!res.ok) throw new Error("An error occurred while generating the file.");
                return res.blob()
            })
            .then(blob =>
            {
                let a = document.createElement("a");
                a.classList.add("hidden");
                a.href = window.URL.createObjectURL(blob);
                a.download = "24hDetailedReport.pdf";

                this.element.parentElement.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(error =>
            {
                if(error.name == "AbortError") return;
                let event = new CustomEvent("show-toast", { detail: error.message });
                window.dispatchEvent(event);
            })
            .finally(() =>
            {
                this.iconTarget.classList.remove("hidden");
                this.loadingTarget.classList.add("hidden");
                this.RUNNING_REQUEST = false;
            })
        })
    }
}